module.exports = __webpack_public_path__ + "img/3.c90f2a79.png";